import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`This portfolio is written using`}
      {" "}
      {` `}
      <a href="https://github.com/gatsbyjs/gatsby" target="_blank">{`Gatsby.js`}</a>
      {`, a React static website generator. The site was originally created in 2016 using an early build of Gatsby but was updated in 2020 to a later version and now uses other React/Gatsby functionality including styled components and mdx page generation.`}</p>
    <p>{`The code can be viewed `}
      <a href="https://github.com/simonrose121/simonrose121.github.io/tree/develop" target="\_blank">{`here`}</a>
      {`.`}</p>
    <p>{`The site is deployed using Github pages.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      